import React, { useEffect, useState } from "react";
import "./Lifetime.scss";
import certificateImg from "../../assets/images/lifetime_payout.jpg";
import { Modal } from "@mui/material";
import downloadIcon from "../../assets/icons/download.svg";
import closeIcon from "../../assets/icons/cross-gray.svg";
import { FormatUSD } from "../../utilities/string";
import ShareCertiWithSocialmedia from "./ShareCertiWithSocialmedia";
import DownloadCertificateMenu from "./DownloadCertificate/DownloadCertificateMenu";

function LifetimeCertificates({ data, publicShareTrue = false }) {
  const certificate = data;
  const [open, setOpen] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(
    publicShareTrue ? data : null
  );
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleOpen = (certificate) => {
    setSelectedCertificate(certificate);
    setOpen(true); // Open modal
    setImageLoaded(false);
  };

  const handleClose = () => {
    setOpen(false); // Close modal
    setSelectedCertificate(null);
  };

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);
  return (
    <div className="lifetime_certificates">
      {/* Small certificate container */}
      {!publicShareTrue && (
        <div
          key={certificate.id}
          className="small_certificate_container"
          onClick={() => handleOpen(certificate)} // Open the modal on small image click
        >
          <div className="certificate_container_header">
            <DownloadCertificateMenu
              name={certificate?.name}
              icon={<img src={downloadIcon} alt="" className="download_icon" />}
              // The artwork only exists inside the modal, so open it first.
              onBeforeDownload={() => handleOpen(certificate)}
            />
            <h3 className="certificate_title">{certificate?.title}</h3>
          </div>
          <div className="certificateImgContainer">
            <img
              src={certificateImg}
              alt="Certificate"
              className="small_certificate_image"
              style={{ cursor: "pointer" }}
            />

            {/* Certificate Name */}
            <div className="small_lifetime_certificate_name">
              {certificate?.name}
            </div>

            {/* Certificate Amount */}
            <div className="small_lifetime_certificate_amount">
              {FormatUSD(certificate?.amount)}
            </div>

            <div className="small_lifetime_certificate_date">
              {certificate?.created_at}
            </div>
          </div>
          <div
            className="frame-btn-container"
            style={{ marginTop: "10px", textAlign: "center" }}
          >
            <a
              href="https://fundedaward.com/products/ac-award?ta_aff=capital"
              target="_blank"
              rel="noreferrer"
              className="frame-certificate-btn"
            >
              Frame Certificate
            </a>
          </div>
        </div>
      )}

      {/* Modal for displaying the certificate in larger view */}
      {publicShareTrue ? (
        <div
          className={`${publicShareTrue ? "stage1certificateCardOverlayShare" : ""
            } certificate-modal`}
        >
          <div className="modal-content">
            <div
              className="certificate_container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="certificate_container_header">
                <DownloadCertificateMenu
                  name={selectedCertificate?.name}
                  icon={<img src={downloadIcon} alt="" className="download_icon" />}
                />
                <h3 className="certificate_title">
                  {selectedCertificate?.title}
                </h3>
                {!publicShareTrue && (
                  <img
                    onClick={handleClose}
                    src={closeIcon}
                    alt="Close"
                    className="close_icon"
                  />
                )}
              </div>
              <div className="certificatePopImage" id="certificateContainer">
                <img
                  src={certificateImg}
                  alt="Certificate"
                  className="certificate_image"
                  style={{ cursor: "pointer" }}
                  onLoad={() => setImageLoaded(true)}
                />

                {imageLoaded && (
                  <>
                    {/* Certificate Name */}
                    <div className="lifetime_certificate_name">
                      {selectedCertificate?.name}
                    </div>

                    {/* Certificate Amount */}
                    <div className="lifetime_certificate_amount">
                      {FormatUSD(selectedCertificate?.amount)}
                    </div>

                    {/* Certificate Date */}
                    <div className="lifetime_certificate_date">
                      {selectedCertificate?.created_at}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Modal open={open} onClose={handleClose}>
          <div className="certificate-modal" onClick={handleClose}>
            <div className="modal-content">
              <div
                className="certificate_container"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="certificate_container_header certificate_popModal_header">
                  <div className="topSection">
                    <h3 className="certificate_title">
                      {selectedCertificate?.title}
                    </h3>
                  </div>
                  <div className="bottomSection">
                    <DownloadCertificateMenu
                      name={selectedCertificate?.name}
                      icon={<img src={downloadIcon} alt="" className="download_icon" />}
                    />
                    <div
                      className="rightSection"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <ShareCertiWithSocialmedia data={selectedCertificate} />
                      {!publicShareTrue && (
                        <img
                          onClick={handleClose}
                          src={closeIcon}
                          alt=""
                          className="close_icon"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="certificatePopImage" id="certificateContainer">
                  <img
                    src={certificateImg}
                    alt="Certificate"
                    className="certificate_image"
                    style={{ cursor: "pointer" }}
                    onLoad={() => setImageLoaded(true)}
                  />

                  {imageLoaded && (
                    <>
                      {/* Certificate Name */}
                      <p className="lifetime_certificate_name">
                        {selectedCertificate?.name}
                      </p>

                      {/* Certificate Amount */}
                      <p className="lifetime_certificate_amount">
                        {FormatUSD(selectedCertificate?.amount)}
                      </p>

                      {/* Certificate Date */}
                      <p className="lifetime_certificate_date">
                        {selectedCertificate?.created_at}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default LifetimeCertificates;
